// extracted by mini-css-extract-plugin
export default {"button":"Xk-z","reviewSort":"Yk-z"};